// target server/customer
const target = 'intersport'; // what configuration to use
const dev = 0; // 1 = development, 0 = production. if dev = 1 use dev config
const finalTarget = dev ? 'dev' : target.toLowerCase();

const { logo, server, company, customer, token } = require(`./cParams/${finalTarget}`);
export default {
    logo,
    server,
    company,
    customer,
    token
};
